
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

//Components
import ChartPie from '../chart/pie';
import { Loading } from 'Components';

//Actions
import { emissionCheckGetCarbDashboardData } from '../../../maintenance/views/main/components/emissionCheckTab/redux/slice';

const EmissionCheck = ({ update, item }) => {
    const dispatch = useDispatch();
    const dashboard = useSelector((state) => state.maintenanceEmissionCheckRedux.dashboard);
    const { messages, locale } = useIntl();

    const [dataChart, setDataChart] = useState({});
    const [loading, setLoading] = useState(true);

    const scanStatuses = useMemo(() => [
        { id: "REQUESTED", color: '#808080', label: messages['emissionCheck_requested'] },
        { id: "COMPLETE", color: '#00AEEF', label: messages['emissionCheck_complete'] },
        { id: "SUBMITTED", color: '#000000', label: messages['emissionCheck_submitted'] },
        { id: "PASS", color: '#66bb6a', label: messages['emissionCheck_pass'] },
        { id: "FAIL", color: '#ffc542', label: messages['emissionCheck_fail'] },
        { id: "ERROR", color: '#DF1A31', label: messages['emissionCheck_error'] }
    ], [locale]);

    // call the Action with the data
    useEffect(() => {
        dispatch(emissionCheckGetCarbDashboardData());
        setLoading(false);
    }, []);

    useEffect(() => {
        setLoading(false);
    }, [dataChart]);

    useEffect(() => {
        if (update > 0) {
            setLoading(true);
            dispatch(emissionCheckGetCarbDashboardData());
        }
    }, [update, item]);

    // load the data in the PIE format
    useEffect(() => {
        if (dashboard?.items) {
            let labels = [];
            let data_labels = [];
            let data = [];
            let backgroundColor = [];
            const all_total = dashboard?.items.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.total;
            }, 0);

            dashboard?.items.forEach(item => {
                if (item.label) {
                    const statusData = scanStatuses.find(s => s.id == item.label)
                    const percentage = parseFloat(item.total * 100 / all_total).toFixed(1);
                    labels.push(statusData?.label + ' (' + percentage + '%)');
                    data_labels.push(item.total);
                    data.push(item.total);
                    backgroundColor.push(statusData?.color);
                }
            });

            setDataChart({
                title: messages['dashboardPanel_carbAllUnits'],
                labels,
                data: data_labels,
                datasets: [{
                    label: '',
                    data,
                    backgroundColor
                }]
            });
        }
    }, [dashboard, locale]);

    return (
        <>
            {loading ?
                <Loading overlay show style={{ zIndex: 4 }} />
                :
                <>
                    {
                        dataChart?.data?.length ?
                            <ChartPie data={dataChart} />
                            :
                            <span>{messages['dashboardPanel_noUnits_EC']}</span>
                    }
                </>
            }
        </>
    );
}

export default EmissionCheck;